import React from 'react';
import { observer } from 'mobx-react';
import ProfileSettings from './ProfileSettings';
import ProfileSettingsStore from './ProfileSettings.store';

const profileSettingsStore = new ProfileSettingsStore();

export default observer(() => <ProfileSettings store={profileSettingsStore} />);
